import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Documentation.css';
import LaunchMonitorGuides from './LaunchMonitorGuides';
import FAQSection from './FAQSection';
import DataFormatGuide from './DataFormatGuide';
import TroubleshootingGuide from './TroubleshootingGuide';

const Documentation = () => {
  const [activeSection, setActiveSection] = useState('launch-monitors');

  const handleSectionChange = (section) => {
    setActiveSection(section);
  };

  return (
    <div className="documentation-container">
      <div className="documentation-header">
        <h1>RangeDat Documentation</h1>
        <p>Learn how to get the most out of RangeDat with our comprehensive guides and tutorials.</p>
      </div>

      <div className="documentation-content">
        <div className="documentation-sidebar">
          <div className="sidebar-section">
            <h3>Getting Started</h3>
            <ul>
              <li 
                className={activeSection === 'launch-monitors' ? 'active' : ''}
                onClick={() => handleSectionChange('launch-monitors')}
              >
                Launch Monitor Export Guides
              </li>
              <li 
                className={activeSection === 'data-format' ? 'active' : ''}
                onClick={() => handleSectionChange('data-format')}
              >
                Data Format Guide
              </li>
              <li 
                className={activeSection === 'troubleshooting' ? 'active' : ''}
                onClick={() => handleSectionChange('troubleshooting')}
              >
                Troubleshooting
              </li>
            </ul>
          </div>

          <div className="sidebar-section">
            <h3>Help & Support</h3>
            <ul>
              <li 
                className={activeSection === 'faq' ? 'active' : ''}
                onClick={() => handleSectionChange('faq')}
              >
                Frequently Asked Questions
              </li>
              <li>
                <a href="mailto:support@rangedat.com" className="external-link">
                  Contact Support
                </a>
              </li>
            </ul>
          </div>

          <div className="sidebar-section">
            <h3>Resources</h3>
            <ul>
              <li>
                <Link to="/blog/getting-started" className="external-link">
                  Getting Started Guide
                </Link>
              </li>
              <li>
                <Link to="/blog/data-analysis" className="external-link">
                  Data Analysis Tips
                </Link>
              </li>
              <li>
                <Link to="/blog/improve-your-game" className="external-link">
                  Improve Your Game
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="documentation-main">
          {activeSection === 'launch-monitors' && <LaunchMonitorGuides />}
          {activeSection === 'data-format' && <DataFormatGuide />}
          {activeSection === 'troubleshooting' && <TroubleshootingGuide />}
          {activeSection === 'faq' && <FAQSection />}
        </div>
      </div>
    </div>
  );
};

export default Documentation;
